// extracted by mini-css-extract-plugin
export var Input = "default-module--Input--bzshW";
export var Text_Input = "default-module--Text_Input--1BF60";
export var Numeric_Input = "default-module--Numeric_Input--1GLd5";
export var Password_Input = "default-module--Password_Input--12Wei";
export var Email_Input = "default-module--Email_Input--2G6Nq";
export var Select = "default-module--Select--FfSgh";
export var Choice_Label = "default-module--Choice_Label--1eXKF";
export var Choice_Label_Checked = "default-module--Choice_Label_Checked--pfgfN";
export var Choice_Input = "default-module--Choice_Input--1B7ZF";